<template>
	<div style="width:90%">
		<div class="container_body">
		<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<el-form-item  label="用户Id:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户Id">
								</el-input>
							</el-form-item>
							<el-form-item label="账号" >
								<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入手机号">
								</el-input>
							</el-form-item>
							<el-form-item label="手机号:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入手机号">
								</el-input>
							</el-form-item>
							<el-form-item label="统计日期">
								<div class="block">
									<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd"
										type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
										>
									</el-date-picker>
								</div>
							</el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="performaReport.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column  prop="userId" label="用户Id" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="statisticsMonthDay" label="统计时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  prop="username" label="账号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="selfPowerYesterday" label="用户昨日总算力" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="selfPowerIncreasedThisDay" label="用户日增算力" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="selfPowerYesterday" label="用户昨日总算力" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="teamPowerIncreasedThisDay" label="社区日增算力" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column  label="社区昨日总算力" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div>{{(scope.row.teamPowerYesterday).toFixed(2)}}</div>
				</template>
			</el-table-column>
			
			<!-- <el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<!-- <el-table-column  label="操作"  fixed="right" align="center">
				
			</el-table-column> -->
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="performaReport.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
			:total="performaReport.total" @size-change="handleSizeChange">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		data() {
			return{
				searchInfo:{},
				loading:false,
				page: {
					pageNum: 1,
					pageSize: 10
				},
				performaReport:{}
			}
		},
		methods:{
			search(){
				this.page.pageNum = 1;
				this.pereportList()
			},
			empty(){
				this.searchInfo = {}
			},
			downloadFile(){
				
			},
			pageChange(data) {
				this.page.pageNum = data
				this.pereportList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.pereportList()
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pereportList(){
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					...this.searchInfo
				}
				this.$api.selectPerforList(data).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.performaReport = res.data
					}
				})
			}
			
		},
		created() {
			this.pereportList()
		}
	}
</script>

<style>
</style>